import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=ed15be76&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=ed15be76&prod&lang=css"
import style1 from "./dialog.vue?vue&type=style&index=1&id=ed15be76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed15be76",
  null
  
)

export default component.exports